module.exports = __webpack_public_path__ + "static/img/1.799c5a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/1.png
// module id = itQV
// module chunks = 0